import { motion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { useConfig } from "@/context/ConfigContext";

export function Integrations() {
  const { config } = useConfig();
  const img = config?.crashready_integrations_image;
  if (!img) return null;

  return (
    <section
      className="relative mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32"
      data-testid="integrations-section"
    >
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <div>
          <Reveal>
            <p className="font-mono text-xs text-white/40">
              04 // INTEGRATIONS
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display mt-6 text-4xl font-light leading-tight tracking-tight text-white sm:text-5xl">
              Powering Every
              <br />
              <span style={{ color: "var(--accent)" }}>Legal CRM.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-body mt-6 max-w-lg leading-relaxed text-white/55">
              One connection. Endless impact. Crash Ready plugs into the tools
              legal teams already trust — Clio, Neos, Litify, MyCase,
              PracticePanther, Leap, CosmoLex and more — so your cases, clients
              and evidence stay connected across the entire ecosystem.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="font-mono mt-8 text-xs tracking-[0.2em] text-white/40">
              YOUR CASES. YOUR CLIENTS. ALL CONNECTED.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <motion.div
            whileHover={{ scale: 1.02 }}
            transition={{ type: "spring", stiffness: 180, damping: 20 }}
            className="relative"
          >
            <div className="overflow-hidden rounded-2xl border border-white/10 bg-black">
              <img
                src={img}
                alt="Crash Ready integrations with leading legal CRMs"
                className="w-full object-contain"
                loading="lazy"
                data-testid="integrations-image"
              />
            </div>
            <div
              className="pointer-events-none absolute -inset-6 -z-10 rounded-3xl opacity-25 blur-3xl"
              style={{ background: "var(--accent)" }}
            />
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
}
